import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Cooperation extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        if (
            content &&
            content.pcCooperationAd &&
            content.pcCooperationAd.data &&
            content.pcCooperationAd.data.length > 0
        ) {
            return (
                <div className={styles.box}>
                    <div data-title="合作伙伴">
                        <span className={styles.title}>合作伙伴</span>
                        <span className={styles.line} />
                    </div>
                    <div className={styles.coor}>
                        {content.pcCooperationAd.data.map((item, index) => (
                            <a
                                key={index}
                                href={item.url}
                                className={index % 4 === 3 ? '' : styles.item_box}
                                target="_blank">
                                <img src={item.img} width={142} height={27} />
                            </a>
                        ))}
                    </div>
                </div>
            );
        }

        return null;
    }
}

export default errorBoundary(Cooperation);
